define('SearchKeywords/searchKeywords',[
    "LearningLibrarySearchResults/learningLibrarySearchResults"
],
function (learningLibrarySearchResults) {
    
    function init() {       
        $("#searchkeywordstxt").off("keyup").on("keyup", keywordInputChanged);   
        $("#searchkeywordicon").off("click").on("click", searchIconClick);
    }

    function searchIconClick() {
        executeSearch();
    }

    function keywordInputChanged(event) {
        if (event.key === "Enter")
            executeSearch();        
    }

    function executeSearch() {    
        var navigateTo = $("#searchkeywordstxt").data("navigateTo");
        if (navigateTo) {
            window.location.href = navigateTo + "?keyword=" + $("#searchkeywordstxt").val();
            return;
        }

        learningLibrarySearchResults.getSearchResults($("#searchkeywordstxt").val(), null, null, null, 0);
    }
    
    return {
        init: init        
    };
});

